import axios from 'axios';

const apiSecundaria = axios.create({ baseURL: 'http://45.35.104.141:6060/api' });

export default apiSecundaria;